import {db} from "../firebase";
import {AssessmentType} from "../db/models/assessment";
import {Collections} from "./collections";

export const getAssessment = (assessmentId: string): Promise<AssessmentType | null> => {
    if (!assessmentId) return Promise.resolve(null);

    return db
        .collection(Collections.ASSESSMENTS)
        .doc(assessmentId)
        .get()
        .then((doc) => {
            if (doc.exists) return doc.data() as AssessmentType;
            else return null;
        })
        .catch((error) => {
            return null;
        });
};
